<script setup lang="ts">
import VSteps from "../Steps/VSteps.vue";

defineProps<{
  steps: string[]
}>();

const currentStep = defineModel<number>("modelValue", { default: 0 });
</script>

<template>
  <VSteps v-model="currentStep" :steps="steps" />
</template>
